import { Token } from '../services/Token.js';
import { Auth } from '../services/Auth.js';

/**
 * Verifica desde el backend la autenticidad del token, además de que no esté expirado.
 */
export const verifyTokenMiddleware = async (to, from, next) => {

    if (!to.meta.requiresAuth) {
        return next();
    }

    const token = Token.get();

    if (!token) {
        return next({ name: 'login' });
    }

    if (await Token.isValid(token)) {
        return next();
    }

    Auth.logout();

    return next({ name: 'login' });
}